/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface WorkLocationsViewModel { 
    /**
     * 工作地點資料Id
     */
    workLocationId?: number;
    /**
     * 工作地點名稱
     */
    workLocationName?: string;
    /**
     * 排序
     */
    sortNo?: number;
}